<template>
  <div class="head-info" :class="center && 'center'">
    <span style="font-size: 15px;">{{ title }}</span>
    <p>
      <a style="font-size: 20px !important; font-weight: 600;">{{ content }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'HeadInfo',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    title: {
      default: ''
    },
    // eslint-disable-next-line vue/require-prop-types
    content: {
      default: ''
    },
    // eslint-disable-next-line vue/require-prop-types
    bordered: {
      default: false
    },
    // eslint-disable-next-line vue/require-prop-types
    center: {
      default: true
    }
  }
}
</script>

<style lang="less" scoped>
.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 0.95rem;
    line-height: 32px;
    margin-bottom: 4px;
  }
  p {
    line-height: 32px;
    margin: 0;
    a {
      font-weight: 600;
      font-size: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/HeadInfo.vue